import React from "react";

// Rend l'icône d'une stat : emoji (ex. ❤️ pour la vie) si défini, sinon l'image `icon`.
// `size` pilote la largeur/hauteur de l'image ET la taille de police de l'emoji,
// pour un rendu visuellement équivalent d'un site à l'autre.
export function StatIcon({
  st,
  size,
}: {
  st: { icon?: string; emoji?: string };
  size: number;
}) {
  if (st.emoji) {
    return (
      <span style={{ fontSize: size, lineHeight: 1, display: "inline-block" }}>
        {st.emoji}
      </span>
    );
  }
  if (st.icon) {
    return (
      <img
        src={st.icon}
        style={{ width: size, height: size, objectFit: "contain" }}
      />
    );
  }
  return null;
}
